var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4355 26.1361L31.9997 20.7718V6.10962L20.4355 26.1361Z",
    fill: "#FF596E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20.772V32.4547L43.5642 26.1362L32 20.772Z",
    fill: "#FF596E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9997 20.772V32.4547L20.4355 26.1362L31.9997 20.772Z",
    fill: "#800010"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5642 26.1361L32 20.7718V6.10962L43.5642 26.1361Z",
    fill: "#800010"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9993 36.9647V49.4164L20.2129 30.5239L31.9993 36.9647Z",
    fill: "#FF596E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36.9647V49.4164L43.7864 30.5239L32 36.9647Z",
    fill: "#800010"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7324 33.3775L48.4025 40.8707L54.2504 31.1021L45.7324 33.3775Z",
    fill: "#800010"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4023 40.8707L54.2502 39.1382V31.1021L48.4023 40.8707Z",
    fill: "#FF596E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2501 39.1382L45.7321 53.3705L39.2617 56.1407L48.4022 40.8707L54.2501 39.1382Z",
    fill: "#800010"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 39.1382L18.2679 53.3705L24.7384 56.1407L15.5979 40.8707L9.75 39.1382Z",
    fill: "#FF596E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 56.1407L18.2678 33.3774L15.5977 40.8707L24.7382 56.1407H31.9998Z",
    fill: "#800010"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2679 33.3775L15.5979 40.8707L9.75 31.1021L18.2679 33.3775Z",
    fill: "#FF596E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5979 40.8707L9.75 39.1382V31.1021L15.5979 40.8707Z",
    fill: "#800010"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56.1407L45.732 33.3774L48.4021 40.8707L39.2616 56.1407H32Z",
    fill: "#FF596E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeth);
export default __webpack_public_path__ + "static/media/meth.b73f8c6831d15f6371597432ee862313.svg";
export { ForwardRef as ReactComponent };